/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { uploadImageAzure } from "cms/images/image-selector/dialog-select/upload/AzureStorage";
import { Logger } from "cms/utils/log/logger";

export const uploadFiles = async (
    setUploading,
    statusList,
    setUploadStatus,
    files,
    handleOnImageUploaded,
    token
) => {
    setUploading(true);
    const uploaded_images = [];
    let index = 0;
    for (const file of files) {
        const updateProgress = async function (status) {
            Logger.debug(`Uploading ${status.name} ${status.progress} ${status.progress}`);
            statusList[index] = status;
        };
        // get a User Delegate SAS - for Azure Storage Blob
        // const sas_response = await SimpliCityAdminSDK.images.getToken(storageAccountName, containerName, accessToken)
        const sas_response = await SimpliCityAdminSDK.images.getToken(token);
        const {
            sas,
            storageAccountName,
            storageAccount,
            containerName,
            fileUrlBase
        } = sas_response;
        Logger.debug("SAS TOKEN", sas);
        
        // ******************* UPLOAD TO AZURE STORAGE **************************
        Logger.debug(`Uploading file: ${file.name}`);
        setUploadStatus({ status: "INCOMPLETE", message: "The upload has begun." });
        const uploadResult = await uploadImageAzure(
            storageAccount, containerName, file, sas, updateProgress,
        );
        setUploadStatus(uploadResult);
        
        // *****************  Add image to simplicity API  ***********************
        if (uploadResult.status === "ERROR") {
            Logger.error(uploadResult);
            throw Error(uploadResult.message);
        } else {
            const storage_url = `${storageAccount}/${containerName}/${encodeURIComponent(file.name)}`;
            const public_url = `${fileUrlBase}/${encodeURIComponent(file.name)}`;
            const ext = file.name.split(".").pop();
            const payload = {
                // organization: organization,
                title: encodeURIComponent(file.name),
                storage_account: storageAccountName,
                storage_container: containerName,
                storage_filepath: encodeURIComponent(file.name),
                storage_url: storage_url,
                url: public_url,
                file_name: file.name,
                file_ext: ext,
                file_type: file.type,
                file_size: file.size,
                width: file.width || 0,
                height: file.height || 0,
            };
            
            // Add record to the database
            const image_response = await SimpliCityAdminSDK.images.create(token, payload);
            Logger.debug(image_response);
            uploaded_images.push(image_response);
        }
        index++;
    }
    handleOnImageUploaded(uploaded_images);
    
    setUploading(false);
};
